import * as MuiCore from '@mui/material';
import * as MuiIcons from '@mui/icons-material';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import * as styles from './styles';
import clsx from 'clsx';
import { AppRoute } from '../../routes';
import { pushAppRoute } from '../../data/domain/route-manager';

const ActionRow: React.FC<{ label: string; appRoute: AppRoute }> = (props) => {
    const history = useHistory();
    const classes = styles.useStyles();

    const onClick = (): void => {
        //if ('siteId' in props.appRoute)
            pushAppRoute(history, props.appRoute);
    };

    return (
        <MuiCore.List dense>
            <MuiCore.ListItem style={{ backgroundColor: 'transparent' }}>
                <MuiCore.ListItemText
                    className={clsx(classes.actionRow)}
                    onClick={onClick}
                    primary={props.label}
                    primaryTypographyProps={{
                        style: { fontWeight: styles.fontWeights.bold },
                        color: 'primary'
                    }}
                />
                <MuiCore.ListItemSecondaryAction className={clsx(classes.actionRow)}>
                    <MuiCore.IconButton onClick={onClick}>
                        <MuiIcons.ChevronRight />
                    </MuiCore.IconButton>
                </MuiCore.ListItemSecondaryAction>
            </MuiCore.ListItem>
        </MuiCore.List>
    );
};

export { ActionRow };
